import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import * as xlsx from 'xlsx'
import { Pagination, Input, SelectItem, Select } from "@nextui-org/react";
import {
  Button,
} from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AllRecords = () => {


  const navigate = useNavigate();

  const { user } = useSelector(state => state.user);

  const [uichange, setuichange] = useState(false);

  const [paginationOn, setPaginationOn] = useState(true);
  const [trips, settrips] = useState([]);
  const [page, setPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState()

  const [loading, setloading] = useState(false);

  const [deleteOption, setDeleteOption] = useState(false);
  const [checkedRecords, setCheckedRecords] = useState([]);
  const [checkedRecordCount, setCheckedRecordCount] = useState([]);

  //counts the number of records checked
  useEffect(() => {
    setCheckedRecordCount(checkedRecords.length);
  }, [checkedRecords])

  const getAllTrips = async () => {
    try {
      // console.log(selectedItem);

      setPaginationOn(true);
      setloading(true);
      const response = await axios.get(`/trip/get/all?page=${page}`);
      setloading(false);
      if (response.data.success) {
        setTotalEntries(response.data.totalEntries);
        settrips(response.data.tripData);
        setTotalPages(response.data.totalPages);
      }
    } catch (error) {
      setloading(false);
      // console.log(error);
      toast.error(error.response.data.message);
    }
  };
  useEffect(() => {
    getAllTrips();
  }, [page, uichange]);

  const handlePageChange = (page) => {
    setPage(page);
  };

  useEffect(() => {
    if (!selectedItem) {
      setLable("Search");
    }
  }, []);

  const [label, setLable] = useState("Search");
  const [selectedItem, setSelectedItem] = useState("LR No");


  const handleSearchItem = (e) => {
    const s = e.target.value;
    if (s === "") {

      getAllTrips();
    }
  };

  const handleSelectedChange = (e) => {
    setSelectedItem(e.target.value);
  }

  const selectedValue = React.useMemo(
    () => Array.from(selectedItem).join(", ").replaceAll("_", " "),
    [selectedItem]
  );

  const handleSearchBar = async (e) => {
    const s = e.target.value;

    // console.log({ selectedItem });


    if (e.key === "Enter") {
      if (selectedItem === "GPI No") {
        try {
          let formData = {
            gpiNo: s,
          };

          const response = await axios.get("/trip/get/byGpi", {
            params: formData,
          });
          if (response.data.success) {
            settrips(response.data.tripData);
            setPaginationOn(false);
          }
        } catch (error) {
          toast.error(error.response.data.message);
        }
      } else if (selectedItem === "LR No") {
        try {
          let formData = {
            lrNo: s,
          };

          const response = await axios.get("/trip/get/byLrNo", {
            params: formData,
          });
          if (response.data.success) {
            settrips(response.data.tripData);
            setPaginationOn(false);
          }
        } catch (error) {
          toast.error(error.response.data.message);
        }
      } else if (selectedItem === "Truck No") {
        try {
          let formData = {
            truckNo: s
          };
          const response = await axios.get("/trip/get/byTruckNo", { params: formData });
          if (response.data.success) {
            settrips(response.data.tripData);
            setPaginationOn(false);
          }
        } catch (error) {
          toast.error(error.response.data.message);
        }
      } else if (selectedItem === "Bill No") {
        try {
          let formData = {
            billNo: s
          };
          const response = await axios.get("/trip/get/tripByBill", { params: formData });
          if (response.data.success) {
            settrips(response.data.tripData);
            setPaginationOn(false);
          }

        } catch (error) {
          toast.error(error.response.data.message);
        }
      }
    }
  };

  const handleDateSearch = async (e) => {
    const date = e.target.value;
    if (date === "") {
      getAllTrips();
    } else {
      try {
        const response = await axios.get("/trip/get/byDate", {
          params: { date },
        });
        if (response.data.success) {
          settrips(response.data.tripData);
          setPaginationOn(false);
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    }
  };

  const [showDateInput, setShowDateInput] = useState(false);
  const [dates, setDates] = useState({
    startDate: "",
    endDate: ""
  })

  const handleDate = (e) => {
    const { name, value } = e.target;
    setDates({
      ...dates,
      [name]: value
    })
  }

  const handleDownload = async () => {

    if (dates.startDate === "" || dates.endDate === "") {
      toast.error('dates required');
      return
    }

    // console.log(dates);
    try {

      const response = await axios.post('/trip/get/tripsByDateRange', dates);
      if (response.data.success) {
        let sheet = [];
        response.data.trips?.forEach((trip) => {
          const formatDate = (date) => new Date(date).toLocaleDateString('en-GB');
          let date = new Date(trip.tripDate).toLocaleDateString('en-GB') + "-" + new Date(trip.tripDate).toLocaleTimeString('en-GB');
          let obj = {
            tripDate: date,
            gpiNo: trip.gpiNo || 0,
            ton: trip.ton || 0,
            lrNo: trip.lrNo || '',
            truckNo: trip.truckNo || '',
            destination: trip.destination || '',
            threePointAmount: trip.threePointAmount || 0,
            threePointBill: trip.threePointBill || '',
            threePointDate: trip.threePointDate ? formatDate(trip.threePointDate) : '',
            companyRate: trip.companyRate || 0,
            companyTotal: trip.companyTotal || 0,
            lorryRate: trip.lorryRate || 0,
            lorryTotal: trip.lorryTotal || 0,
            advancedAmount: trip.advancedAmount || 0,
            advancedAmountDate: trip.advancedAmountDate ? formatDate(trip.advancedAmountDate) : '',
            dieselAmount: trip.dieselAmount || 0,
            balanceAmount: trip.balanceAmount || 0,
            billNo: trip.billNo || '',
            billDate: trip.billDate ? formatDate(trip.billDate) : '',
            tollBillNo: trip.tollBillNo || '',
            tollAmount: trip.tollAmount || 0,
            tollDate: trip.tollDate ? formatDate(trip.tollDate) : '',
            soldToParty: trip.soldToParty || '',
            contactNo: trip.contactNo || 0,
            postPaidAmount: trip.postPaidAmount || 0,
            postPaidDate: trip.postPaidDate ? formatDate(trip.postPaidDate) : '',
            postPaid2Amount: trip.postPaid2Amount || 0,
            postPaid2Date: trip.postPaid2Date ? formatDate(trip.postPaid2Date) : '',
            postPaid3Amount: trip.postPaid3Amount || 0,
            postPaid3Date: trip.postPaid3Date ? formatDate(trip.postPaid3Date) : '',
            extraAmount: trip.extraAmount || 0,
            extraAmountRemark: trip.extraAmountRemark || '',
            unloading: trip.unloading || 0
          };

          sheet.push(obj);

        });

        // sheet = sheet.reverse();

        const workSheet = xlsx.utils.json_to_sheet(sheet);
        const workBook = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(workBook, workSheet, 'Sheet1');
        xlsx.writeFile(workBook, 'AllRecord.xlsx');

      }

    } catch (error) {
      toast.error(error.response.data.message);
    }
  }

  const deleteTrip = async (id) => {
    try {
      const result = window.confirm("Are you sure? want to delete this record?");

      if (result) {
        const response = await axios.delete(`/trip/deleteTrip/${id}`);
        if (response.data.success) {
          setuichange(!uichange);
          toast.success(response.data.message);
        }
      } else {
        return;
      }

    } catch (error) {
      toast.error(error.response.data.message);
    }
  }


  const deleteSelectedRecords = async () => {

    try {
      const password = window.prompt("Enter your login password to delete records!");
      if (!password || password === "") {
        return toast.error("password required!!");
      }

      const resp = await axios.post("/user/verify/password", { password: password });
      if (resp.data.success) {

        // console.log(checkedRecords.length);
        if (checkedRecords.length < 1) {
          toast.error('please select records');
          return
        }

        const response = await axios.post("/trip/deleteManyTrips", { tripsId: checkedRecords });
        if (response.data.success) {
          toast.success(response.data.message);
          setuichange(!uichange);
          setCheckedRecords([]);
          setSelectAll(false);
        }
      }

    } catch (error) {
      toast.error(error.response.data.message);
    }

  }

  // select all for multiple delete

  const [selectAll, setSelectAll] = useState(false);



  useEffect(() => {
    if (selectAll) {
      setCheckedRecords(trips?.map((trip) => trip._id));

    } else {
      setCheckedRecords([]);
      // console.log(checkedRecords.length);
    }
  }, [selectAll, trips])


  const recalculateBalance = async () => {
    if (window.confirm("Are you sure you want to recalculate Balance Amount? If any errors in balanceAmount calculations, you can proceed.")) {
      try {
        const response = await axios.get("/script-run");
        if (response.data.success) {
          toast.success(response.data.message);
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    } else {
      return;
    }

  }


  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="flex flex-row justify-around items-center m-5">
        <div>
          <Input
            label={"Search by date"}
            type="date"
            className="max-w-sm"
            onChange={handleDateSearch}
          />
        </div>
        <div className="flex gap-2 items-center w-[450px]">
          <Input
            type="Search"
            label={label}
            onChange={handleSearchItem}
            onKeyDown={handleSearchBar}
          />
          <Select
            label="Search by Item"
            className=" text-center max-w-xs"
            placeholder={selectedItem}
            onChange={handleSelectedChange}
          // defaultSelectedKeys={selectedItem}

          // onAction={(key) => {
          //   setLable(s + key);
          //   setSelectedItem(key);
          // }}
          >
            <SelectItem key="GPI No">GPI No</SelectItem>
            <SelectItem key="Bill No">Bill No</SelectItem>
            <SelectItem key="LR No">LR No</SelectItem>
            <SelectItem key="Truck No">Truck No</SelectItem>
          </Select>

          <Button className="text-white" onClick={() => setShowDateInput(!showDateInput)} color="warning">Download</Button>
        </div>

        <div>
          <Button onClick={async () => await recalculateBalance()} color="danger"
            title="If any errors in balanceAmount, then it will recalculate">
            Recalculate BalanceAmount
          </Button>
        </div>
      </div>
      <div className="flex justify-evenly">
        <p></p>
        {
          showDateInput ? <>
            <div className="flex flex-col">
              <h3>Download Records</h3>
              <div className="flex items-baseline gap-4 w-[8rem] h-[3rem]">
                <Input
                  name="startDate"
                  label={"From date"}
                  type="date"
                  className="max-w-sm"
                  onChange={handleDate}
                />
                <Input
                  name="endDate"
                  label={"To date"}
                  type="date"
                  className="max-w-sm"
                  onChange={handleDate}
                />
                <i className="fa-solid fa-file-export text-2xl  items-baseline text-orange-300 cursor-pointer" onClick={handleDownload} ></i>
              </div>
            </div>
          </> : <></>
        }
      </div>
      <div>
        <div className="flex justify-between">
          <p className="ml-10 underline">Total Entries: {totalEntries}</p>
          {deleteOption ? <Button onClick={deleteSelectedRecords} color="danger"><i className="fa-solid fa-trash"></i></Button> : null}

          {
            user?.role === "Admin"
            &&
            <Button onClick={() => setDeleteOption(!deleteOption)}
              color="danger"
              className="mr-3">{deleteOption ?
                <span onClick={() => {
                  setCheckedRecords([]);
                  setSelectAll(false);
                }}>Disable Delete</span>
                :
                <span>Delete Records</span>}
            </Button>
          }

        </div>

        {
          // select all button for multiple delete decords
          deleteOption ? <>
            <div className="ml-10">
              <Button onClick={() => setSelectAll(!selectAll)} color="danger">select all</Button>
              {
                checkedRecordCount ? <span className="text-red-500 bg-red-100 p-1 ml-2 rounded-md">Selected-records: {checkedRecordCount}</span> : null
              }
            </div>
          </> : <></>
        }



        <div className="flex flex-col mx-4">
          <div className="-m-1.5 bottom-0 inset-x-0">
            <div className="p-1.5 min-w-full inline-block align-middle">
              <div className="border rounded-lg overflow-hidden mt-5 shadow">
                <div className="max-h-[65vh] w-[97vw] overflow-y-scroll overflow-x-scroll">
                  <table className="min-w-full divide-y divide-gray-200 ">
                    <thead className="bg-gray-50 sticky top-0 z-10">
                      <tr>
                        {
                          deleteOption ?
                            <th
                              scope="col"
                              className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                            ></th> : <></>
                        }
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Edit
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        ></th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          TRIP DATE
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          GPI No.
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          TON
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          LR No
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Truck No.
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Destination
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-smm text-black uppercase"
                        >
                          COMPANY RATE
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-smm text-black uppercase"
                        >
                          COMPANY TOTAL
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-smm text-black uppercase"
                        >
                          LORRY RATE
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          LORRY TOTAL
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          ADVANCE AMOUNT
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          ADVANCE AMOUNT REMARK
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          ADVANCE AMOUNT DATE
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          DIESEL AMOUNT
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          BALANCE AMOUNT
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          SOLD TO PARTY
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          CONTACT
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          POST PAID 1 DATE
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          POST PAID 1 AMOUNT
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          POST PAID 1 REMARK
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          POST PAID 2 DATE
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          POST PAID 2 AMOUNT
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          POST PAID 2 REMARK
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          POST PAID 3 DATE
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          POST PAID 3 AMOUNT
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          POST PAID 3 REMARK
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Extra Amount
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Extra Amount Remark
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Unloading
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Unloading Date
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Unloading Bill
                        </th>



                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Bill DATE
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          Bill NO
                        </th>

                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          TOLL BILL DATE
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          TOLL BILL NO
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          TOLL AMOUNT
                        </th>


                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          3 POINT DATE
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          3 POINT BILL
                        </th>
                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-smm text-black uppercase"
                        >
                          3 POINT AMT
                        </th>


                        <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          INCENTIVE AMOUNT
                        </th>



                        {/* {user?.role === "Admin" ? <th
                          scope="col"
                          className="font-bold px-6 py-3 text-start text-sm text-black uppercase"
                        >
                          DELETE
                        </th> : null} */}

                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {trips?.map((t, index) => {
                        return (
                          <>
                            <tr className="hover:bg-gray-300 cursor-pointer">

                              {
                                deleteOption ? <td className="px-6 py-4 whitespace-nowrap text-sm font-medium ">
                                  < input onChange={(e) => {
                                    if (e.target.checked) {
                                      setCheckedRecords([...checkedRecords, e.target.value])
                                    }
                                    else {
                                      let arr = checkedRecords?.filter((id) => {
                                        return id !== t._id
                                      })
                                      setCheckedRecords(arr);
                                    }

                                  }}
                                    type="checkbox" value={t._id}
                                    //checking the box based on records avalible in checkedRecords state
                                    checked={checkedRecords.includes(t._id)} />
                                </td> : null
                              }

                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                <i onClick={() => navigate(`/updateTrip/${t._id}`)}
                                  className="fa-solid fa-pen-nib text-blue-700 hover:scale-150 transition-transform"></i>
                              </td>

                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {index + 1}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {new Date(t?.tripDate).toLocaleDateString(
                                  "en-GB"
                                ) +
                                  " - " +
                                  new Date(t?.tripDate).toLocaleTimeString()}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.gpiNo}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.ton}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.lrNo}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.truckNo}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.destination}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.companyRate}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.companyTotal}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.lorryRate}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.lorryTotal}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.advancedAmount}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.advanceAmountRemark}
                              </td>

                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t.advancedAmountDate ? new Date(t?.advancedAmountDate).toLocaleDateString("en-GB") : "-"}
                              </td>
                              <td className=" px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.dieselAmount}
                              </td>
                              <td className={`${(t?.balanceAmount === 0 && t?.lorryRate !== 0) ? 'text-green-600 font-bold bg-green-100' : t?.balanceAmount < 0 ? 'text-red-500 font-bold bg-red-100' : 'text-black'} px-6 py-4 whitespace-nowrap text-sm font-medium`}>
                                {t?.balanceAmount}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.soldToParty}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.contactNo}
                              </td>


                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.postPaidDate ? new Date(t?.postPaidDate)?.toLocaleDateString("en-GB") : "-"}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.postPaidAmount}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.postPaidAmountRemark}
                              </td>



                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.postPaid2Date ? new Date(t?.postPaid2Date)?.toLocaleDateString("en-GB") : "-"}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.postPaid2Amount}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.postPaidAmountRemark2}
                              </td>


                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.postPaid3Date ? new Date(t?.postPaid3Date)?.toLocaleDateString("en-GB") : "-"}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.postPaid3Amount}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.postPaidAmountRemark3}
                              </td>


                              <td className={t?.extraAmount ? "px-6 py-4 whitespace-nowrap text-sm font-medium text-red-500 bg-red-100" : null}>
                                {t?.extraAmount}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.extraAmountRemark}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.unloading}
                              </td>

                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.unloadingDate ? new Date(t?.unloadingDate).toLocaleDateString("en-GB") : "-"}
                              </td>
                              <td className={t?.unloadingBill ? "px-6 py-4 whitespace-nowrap text-sm font-medium text-green-700 bg-green-100" : null}>
                                {t?.unloadingBill}
                              </td>


                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.billDate ? new Date(t?.billDate).toLocaleDateString("en-GB") : "-"}
                              </td>
                              <td className={t?.billNo ? "text-green-700 bg-green-100 px-6 py-4 whitespace-nowrap text-sm font-medium" : null}>
                                {t?.billNo}
                              </td>

                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.tollDate ? new Date(t?.tollDate).toLocaleDateString("en-GB") : "-"}
                              </td>
                              <td className={t?.tollBillNo ? "text-green-700 bg-green-100 px-6 py-4 whitespace-nowrap text-sm font-medium" : null}>
                                {t?.tollBillNo}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.tollAmount}
                              </td>

                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium ">
                                {t?.threePointDate ? new Date(t?.threePointDate).toLocaleDateString("en-GB") : "-"}
                              </td>
                              <td className={t?.threePointBill ? "text-green-700 bg-green-100 px-6 py-4 whitespace-nowrap text-sm font-medium" : null}>
                                {t?.threePointBill}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                {t?.threePointAmount}
                              </td>


                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium ">
                                {t?.incentiveAmount}
                              </td>



                              {/* {user?.role === "Admin" ? <td className="text-center">
                                <i onClick={() => deleteTrip(t._id)} className="fa-solid fa-trash text-red-600 hover:scale-150 transition-transform"></i>
                              </td>
                                :
                                null} */}

                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center mt-8">
          {!paginationOn ? (
            <></>
          ) : (
            <Pagination
              color="warning"
              showControls
              total={totalPages}
              initialPage={page}
              onChange={handlePageChange}
            />
          )}
        </div>
      </div >
    </>
  );
};

export default AllRecords;
